<p>Acercade works!</p>
    <a [routerLink]="['/tests/angular']" [queryParams]="{ id: 2222 }" routerLinkActive="active">Pulsa aqui para invocar con queryparam</a>